import { useTranslation } from 'react-i18next';

export default function LanguagesSection() {
  const { t } = useTranslation();

  const languages = [
    { name: t('languages.spanish'), flag: '🇪🇸' },
    { name: t('languages.english'), flag: '🇬🇧' },
    { name: t('languages.russian'), flag: '🇷🇺' }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {t('languages.title')}
        </h2>
        <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
          {t('languages.description')}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-6">
          {languages.map((language, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-lg px-8 py-6 flex items-center gap-4 hover:shadow-lg transition-all duration-300"
            >
              <span className="text-4xl">{language.flag}</span>
              <span className="text-base font-semibold text-gray-900">{language.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}